module.exports = __webpack_public_path__ + "static/media/seller2.2402dbec.svg";